import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/page.tsx");
